import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // This helps you immediately spot env var problems in Vercel logs / console
  console.warn("Missing Supabase env vars. Check REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);


console.log("Supabase URL present?", !!supabaseUrl);
console.log("Supabase anon key present?", !!supabaseAnonKey);
console.log("Anon key length:", supabaseAnonKey?.length);
